module.exports = __webpack_public_path__ + "img/Klaviyo.04f9a9ce.svg";